import React from 'react';

import { generalMessages } from '../../../translates/generalMessages';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import './ContentNotAvailable.scss';

export const ContentNotAvailable: React.FC = () => {
  return (
    <div className="content-not-available">
      <FontAwesomeIcon icon={solid('wifi-slash')} size="lg" bounce />
      <div className="content-not-available__text">
        <FormattedMessage {...generalMessages.contentNotAvailable} />
      </div>
    </div>
  );
};
